module.exports = __webpack_public_path__ + "img/left-grid.885013eb.png";